import OpenAI from "openai";

export function cosineSimilarity(vectorA: number[], vectorB: number[]): number {
  if (vectorA.length !== vectorB.length) {
    return 0;
  }

  const dotProduct = vectorA.reduce((sum, a, i) => sum + a * vectorB[i], 0);
  const magnitudeA = Math.hypot(...vectorA);
  const magnitudeB = Math.hypot(...vectorB);

  if (magnitudeA === 0 || magnitudeB === 0) {
    return 0;
  }

  return dotProduct / (magnitudeA * magnitudeB);
}

export async function getCosineSimilarityScore(
  openAi: OpenAI,
  prompt: string,
  guess: string
): Promise<number> {
  if (guess.toLowerCase() === prompt.toLowerCase()) {
    return 1.0;
  }

  const guessEmbedding = (
    await openAi.embeddings.create({
      model: "text-embedding-3-small",
      input: guess,
      encoding_format: "float",
    })
  ).data[0].embedding;

  const promptEmbedding = (
    await openAi.embeddings.create({
      model: "text-embedding-3-small",
      input: prompt,
      encoding_format: "float",
    })
  ).data[0].embedding;

  return cosineSimilarity(guessEmbedding, promptEmbedding);
}

export const SuccessThreshold = 0.99;

export function isSuccess(score: number): boolean {
  return score >= SuccessThreshold;
}

export const SimilarityThreshold = 0.4;

export function isSimilar(score: number): boolean {
  return score >= SimilarityThreshold;
}

export const StrongSimilarityThreshold = 0.6;
